export default __webpack_public_path__ + "static/media/charette.36860f28.png";